import cn from 'classnames'
import React, { memo, useEffect } from 'react'

//
import { LocationContext, SiteDataContext } from '../../components'
import ButtonNew from '../ButtonNew'
import { NavLink } from '../helpers'

import { BUTTON_VARIANT } from '../ButtonNew/ButtonNew'
import ExpansionPanel from '../ExpansionPanel'
import MenuList from '../MenuList'
import { getUrl } from '@/src/utils/urls'
import { useNavigationData } from '@/src/context/NavigationContext'

const MobileNav = ({
  items = [],
  primaryAction,
  secondaryAction,
  isOpen = false,
  hideTopBar,
  classes
}) => {
  const { isTextRtl } = React.useContext(SiteDataContext)
  const location = React.useContext(LocationContext)
  const { navigationItems } = useNavigationData()
  const { slugPrefix } = location
  const [isSubNavOpen, setSubNavOpen] = React.useState(false)
  const [_subItems, setSubItems] = React.useState([])
  const [_subItemsTitle, setSubItemsTitle] = React.useState('')

  useEffect(() => {
    if (!isOpen && isSubNavOpen) {
      resetSubNav()
    }
  }, [isOpen])

  const renderNavItem = (item) => {
    if (item.url) {
      return (
        <NavLink to={item.url}>
          <div className="c-mobile-nav__nav-item">
            <span className="c-mobile-nav__label">{item.label}</span>
          </div>
        </NavLink>
      )
    }

    return (
      <>
        <ExpansionPanel
          className="c-mobile-nav__nav-item"
          openIconName="tabler-chevron-down"
          closeIconName="tabler-chevron-up"
          label={item.label}
        >
          {item.items.map((option) => {
            return (
              <MenuList
                title={option.title}
                items={
                  option.navigationItems?.map((navItem) => ({
                    id: `menu-item-${navItem.id}`,
                    label: navItem.title || null,
                    subtext: navItem.subtext || null,
                    url: getUrl({
                      navItem: navItem,
                      slugPrefix: slugPrefix,
                      navigationItems: navigationItems
                    }),
                    icon: navItem.icon,
                    image: navItem.image,
                    background: navItem.background,
                    logo: navItem.logo
                  })) || []
                }
                key={option.id}
              />
            )
          })}
        </ExpansionPanel>
      </>
    )
  }

  const resetSubNav = () => {
    setSubNavOpen(false)
    setSubItems([])
    setSubItemsTitle('')
  }

  const renderAction = (item) => (
    <div className="l-container:12/12 l-container--default-spacing c-mobile-nav__item-content">
      {item.label}

      <ButtonNew
        url={item.action.url}
        iconLeft="ti-arrow-narrow-left"
        variant={BUTTON_VARIANT.TERTIARY}
        size={'md'}
      >
        {item.action.label}
      </ButtonNew>
    </div>
  )

  return (
    <div
      className={cn('c-mobile-nav', hideTopBar && 'c-no-topbar', classes, {
        'is-open': isOpen,
        'c-mobile-nav--rtl': isTextRtl
      })}
    >
      <nav>
        <ul className="c-mobile-nav__list c-mobile-nav__item-container">
          {items.map((item, index) => (
            <li key={item.id}>
              {item && !item.action && renderNavItem(item)}
              {item.action && renderAction(item)}
              {index > items.length - 1 ? <div className="c-mobile-nav__list-divider"></div> : null}
            </li>
          ))}
        </ul>
        <div className="c-mobile-nav__actions">
          {secondaryAction && (
            <ButtonNew
              fullWidth={true}
              variant={BUTTON_VARIANT.SECONDARY}
              url={secondaryAction.url}
            >
              {secondaryAction.label}
            </ButtonNew>
          )}
          {primaryAction && (
            <ButtonNew fullWidth={true} variant={BUTTON_VARIANT.GREEN} url={primaryAction.url}>
              {primaryAction.label}
            </ButtonNew>
          )}
        </div>
      </nav>
    </div>
  )
}

export default memo(MobileNav)
